import { initServices } from './serviceConfig'

let _svc
let _that

export default {
  Init: async (that) => {
    _that = that

    _svc = await initServices()

    _svc.interceptors.response.use(
      response => response,
      error => {
        _that.ErrorMixin_HandleError(error)
      }
    )
  },
  // List
  GetList: () => {
    try {
      return _svc.get('Test/List')
    } catch {
      return null
    }
  },

  // Detail
  GetDetail: (id) => {
    try {
      return _svc.get(`Test/Detail/${id}`)
    } catch {
      return null
    }
  },
  SaveDetail: (detail) => {
    try {
      return _svc.put('Test/Detail/Save', detail)
    } catch {
      return null
    }
  }
}
